(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hospitality-gallery"] && !Shopify.designMode) return;
  try {
    
  const showHospitalityImage = (dialog, index) => {
    const items = [...dialog.closest('.hr-hospitality-gallery').querySelectorAll('[data-hr-lightbox-open]')];
    if (!items.length) return;
    const nextIndex = (index + items.length) % items.length;
    const current = items[nextIndex];
    const image = dialog.querySelector('img');
    image.src = current.href;
    image.alt = current.dataset.alt || '';
    dialog.dataset.imageIndex = nextIndex;
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-hr-lightbox-open]');
    if (open) {
      const gallery = open.closest('.hr-hospitality-gallery');
      const dialog = gallery && gallery.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        const items = [...gallery.querySelectorAll('[data-hr-lightbox-open]')];
        showHospitalityImage(dialog, items.indexOf(open));
        dialog.showModal();
      }
      return;
    }
    const step = event.target.closest('[data-hr-lightbox-step]');
    if (step) {
      const dialog = step.closest('dialog');
      showHospitalityImage(dialog, Number(dialog.dataset.imageIndex || 0) + Number(step.dataset.hrLightboxStep));
      return;
    }
    const close = event.target.closest('[data-hr-lightbox-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.hr-hospitality-gallery__dialog')) event.target.close();
  });
  document.addEventListener('keydown', (event) => {
    const dialog = document.querySelector('.hr-hospitality-gallery__dialog[open]');
    if (!dialog || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    showHospitalityImage(dialog, Number(dialog.dataset.imageIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
